import React, { useEffect, useState } from "react";
import { CircularProgress, Typography, Tooltip } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Link } from "react-router-dom";

import Header from "../../../Header1";
import { API_URL } from "../../../../api";
import { useAppContext } from "../../../../Context/UseContext";

const ReportList = () => {
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(25);

  const [loading, setLoading] = useState(true);

  const [rowCount, setRowCount] = useState(0);
  const [customers, setCustomers] = useState([]);
  const { showFullPhoneNumberemail } = useAppContext();

  const getApprovalStatus = (approval, deleted_at) => {
    if (deleted_at) return "Deleted";
    switch (approval) {
      case 10:
        return "Pending";
      case 15:
        return "Disable";
      case 20:
        return "Approved";
      case 30:
        return "Rejected";
      case 40:
        return "Incomplete Registration";
      default:
        return "N/A";
    }
  };

  const fetchData = async (page, pageSize) => {
    try {
      const response = await fetch(
        `${API_URL}admin/report/?limit=${pageSize}&pageNo=${page + 1}`
      );
      const data = await response.json();
      const formattedData = data.results.map(item => ({
        id: item.user_id,
        name: `${item.first_name} ${item.last_name || ""}`, // Combining first and last name
        approval: getApprovalStatus(item.approval, item.deleted_at),
        // age: new Date().getFullYear() - new Date(item.birthday).getFullYear(),
        phone: item.phone || "N/A",
        email: item.email || "N/A",
        country: item.country || "N/A", // Assuming address is optional
        reason: item.reason || "N/A",
        gender: item.gender === 1 ? "Men" : "Women",
        created_at: new Date(item.reported_date).toLocaleDateString("en-US", {
          year: "numeric",
          month: "long",
          day: "numeric",
        }),

        birthday: new Date(item.birthday).toLocaleDateString("en-US", {
          year: "numeric",
          month: "long",
          day: "numeric",
        }),
      }));

      setCustomers(formattedData);

      setRowCount(data.total); // Assuming your API response contains the total number of records
    } catch (err) { }
  };

  useEffect(() => {
    const fetchDataloading = async () => {
      try {
        await Promise.all([fetchData(page, pageSize)]);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    };

    fetchDataloading();
  }, [page, pageSize]);

  const formatPhoneNumber = phoneNumber => {
    if (phoneNumber && phoneNumber?.length >= 6) {
      const visibleDigits = 3;
      const maskedSection = phoneNumber
        .substring(visibleDigits, phoneNumber?.length - visibleDigits)
        .replace(/\d/g, "*");
      const visiblePart =
        phoneNumber.substring(0, visibleDigits) +
        maskedSection +
        phoneNumber.substring(phoneNumber?.length - visibleDigits);
      return visiblePart;
    }
    return phoneNumber || "N/A";
  };

  const formatEmailAddress = email => {
    if (email && email !== "N/A") {
      const parts = email.split("@");
      const visiblePart = `${parts[0].charAt(0)}***@${parts[1]}`;
      return visiblePart;
    }
    return "N/A";
  };

  const columns = [
    {
      field: "name",
      headerName: "Name",
      flex: 1,
    },

    {
      field: "reason",
      headerName: "Reason",
      type: "number",
      headerAlign: "left",
      align: "left",
      renderCell: params => (
        <Tooltip
          title={
            <Typography sx={{ fontSize: "14px" }}>{params.value}</Typography>
          }
          arrow
        >
          <Typography noWrap>{params.value}</Typography>
        </Tooltip>
      ),
    },
    {
      field: "phone",
      headerName: "Phone Number",
      flex: 1,
      renderCell: params => (
        <Typography>
          {showFullPhoneNumberemail
            ? params.value
            : formatPhoneNumber(params.value)}
        </Typography>
      ),
    },
    {
      field: "email",
      headerName: "Email",
      flex: 1,
      renderCell: params => (
        <Typography>
          {showFullPhoneNumberemail
            ? params.value
            : formatEmailAddress(params.value)}
        </Typography>
      ),
    },
    {
      field: "birthday",
      headerName: "Birthday",
      flex: 1,
    },

    {
      field: "gender",
      headerName: "Gender",
      flex: 1,
    },
    {
      field: "country",
      headerName: "Locations",
      flex: 1,
    },
    {
      field: "created_at",
      headerName: "Reported",
      flex: 1,
    },
    {
      field: "status",
      headerName: "Link",
      flex: 1,
      renderCell: params => (
        <Link
          to={`/admin/user/report/${params.row.id}`}
          className="text-primary text-decoration-none"
        >
          Show
        </Link>
      ),
    },
  ];

  return (
    <div className="container mt-4">
      <Header
        mb={2}
        title="Reports List"
        subtitle="List of reported users for future reference"
      />
      {loading ? (
        <div className="d-flex justify-content-center align-items-center vh-100">
          <Typography variant="body1" className="me-2">
            Hang tight, we're getting things ready for you!
          </Typography>
          <CircularProgress />
        </div>
      ) : (
        <div>
          <div className="datagrid-wrapper mt-5">
            <DataGrid
              rows={customers}
              columns={columns}
              components={{ Toolbar: GridToolbar }}
              pagination
              pageSize={pageSize}
              onPageSizeChange={newPageSize => setPageSize(newPageSize)}
              rowsPerPageOptions={[25, 50, 100]}
              paginationMode="server"
              onPageChange={newPage => setPage(newPage)}
              rowCount={rowCount}
              componentsProps={{
                pagination: {
                  sx: {
                    "& .MuiButtonBase-root": { color: "#fff" },
                    "& .MuiPaginationItem-root": { color: "#fff" },
                  },
                },
              }}
              autoHeight
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ReportList;
